import React from 'react';
import styled from 'styled-components';
import { Genre } from "types/genre";

interface SortedGenre {
  primary: string[];
  secondary: string[];
}

interface GenreInfoProps {
  genres?: Genre[];
}

export const GenreInfo: React.FC<GenreInfoProps> = props => {
  const { genres } = props;
  const sortedGenre = genres?.reduce((result: SortedGenre, genre) => {
    if (genre.is_primary) {
      return { ...result, primary: [...result.primary, genre.name] };
    }

    return { ...result, secondary: [...result.secondary, genre.name] };
  }, { primary: [], secondary: [] });

  return (
    <Container>
      {genres?.length && sortedGenre ? (
        <>
          <Row>
            <Highlight>{sortedGenre.primary.join(', ')}</Highlight>
          </Row>
          <Row>{sortedGenre.secondary.join(', ')}</Row>
        </>
      ) : '-'}
    </Container>
  )
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
`;

const Highlight = styled.span`
  font-weight: 600;
`;

const Row = styled.div``;
